import {useZoneToStorePerformance} from "../hooks/sales";
import ZoneToStorePerformance from "./index";

export default function SalesZoneToStorePerformance() {
    const { data: sortedData, isLoading } = useZoneToStorePerformance();

    return <ZoneToStorePerformance data={sortedData} isLoading={isLoading} />
}